var React = require('react');

function DoubleQuotationMarks (props) {
    return React.createElement("svg",props,[React.createElement("path",{"data-name":"Path 5704","d":"M42.515,5.834v6.752c-8.881.776-15.156,5.167-18.56,13.893,5.61,1.22,10.067,3.659,13.3,8.049A20.04,20.04,0,1,1,1.2,48.354C-.8,26.5,20.174,4.725,42.515,5.834Z","transform":"translate(-1.07 -5.793)","fill":"#e03116","key":0}),React.createElement("path",{"data-name":"Path 5705","d":"M89.565,5.834v6.752c-8.881.776-15.156,5.167-18.56,13.892,5.61,1.22,10.067,3.659,13.3,8.049A20.04,20.04,0,1,1,48.253,48.354C46.235,26.5,67.213,4.725,89.554,5.834Z","transform":"translate(4.046 -5.793)","fill":"#e03116","key":1})]);
}

DoubleQuotationMarks.defaultProps = {"data-name":"Encompass Vector Graphics_01-12","width":"93.611","height":"60.704","viewBox":"0 0 93.611 60.704"};

module.exports = DoubleQuotationMarks;

DoubleQuotationMarks.default = DoubleQuotationMarks;
